import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      size: 'desktop'
    }
  },
  mounted () {
    if (window.innerWidth < 813) {
      this.size = 'mobile'
    } else {
      this.size = this.ua.platform.type
    }
    window.addEventListener('resize', () => {
      // console.log(window.innerWidth)
      if (window.innerWidth < 813) {
        this.size = 'mobile'
      } else {
        this.size = this.ua.platform.type
      }
    })
  },
  computed: {
    ...mapGetters(['options', 'ua', 'ml']),
    browser () {
      return this.ua.browser.name
    },
    platform () {
      return this.size
    }
  }
}
